import React from 'react'

interface Props {
  label: string
  children: React.ReactNode
}

export const CustomFieldRow = ({label, children}: Props) => {
  return (
    <div className="grid grid-cols-[150px_1fr] px-12 py-2 text-14 items-start">
      <div className="text-placeholder pt-6">{label}</div>
      <div className="flex items-start w-full gap-2">{children}</div>
    </div>
  )
}
